(() => {
  'use strict';
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank') return;
    if (link.matches('[data-gs-support-guarantee-open]')) {
      const dialog = document.querySelector('[data-gs-pdp-support] dialog[id$="-guarantee"]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      link.setAttribute('aria-controls', dialog.id);
      if (!dialog.open) dialog.showModal();
      return;
    }
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.hash !== '#buy-area') return;
    const offer = document.getElementById('buy-area');
    if (!offer) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const header = document.querySelector('.gs-lp-header');
    const inset = header ? header.getBoundingClientRect().height + 18 : 18;
    const top = Math.max(0, window.scrollY + offer.getBoundingClientRect().top - inset);
    window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }, true);
  const timers = document.querySelectorAll('[data-gs-sale-deadline]');
  timers.forEach(timer => {
    const end = Date.parse(timer.dataset.gsSaleDeadline || '');
    if (!Number.isFinite(end) || end <= Date.now()) return;
    const parts = ['days', 'hours', 'minutes', 'seconds'].map(name => timer.querySelector(`[data-gs-sale-${name}]`));
    if (parts.some(part => !part)) return;
    const update = () => {
      const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      parts.forEach((part, index) => { part.textContent = String(values[index]).padStart(2, '0'); });
      timer.hidden = remaining === 0;
      return remaining > 0;
    };
    update();
    const interval = window.setInterval(() => { if (!update()) window.clearInterval(interval); }, 1000);
  });
})();

